module.exports = __webpack_public_path__ + "img/bee.e84ba54b.jpg";